import React from 'react';
import './StatCard.css';

const StatCard = ({ icon: Icon, label, value, sub, color = 'green', trend }) => {
  return (
    <div className={`stat-card stat-card--${color}`}>
      <div className="stat-card__body">
        <div className="stat-card__info">
          <span className="stat-card__label">{label}</span>
          <span className="stat-card__value">{value}</span>
          {sub && <span className="stat-card__sub">{sub}</span>}
          {trend !== undefined && (
            <span className={`stat-card__trend ${trend >= 0 ? 'stat-card__trend--up' : 'stat-card__trend--down'}`}>
              {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}% from last month
            </span>
          )}
        </div>
        {Icon && (
          <div className="stat-card__icon">
            <Icon size={22} strokeWidth={1.8} />
          </div>
        )}
      </div>
      <div className="stat-card__accent" />
    </div>
  );
};

export default StatCard;
